/**
 * @typedef {"unfinished" | "errored" | "loaded"} ScriptLoadingStatus
 */
module.exports.status = {
    unfinished: 'unfinished',
    errored: 'errored',
    loaded: 'loaded',
};
